import { readStoredJson, writeStoredJson } from '../../app/durable-state.js';

const VERSION = 1;
const KEY_PREFIX = 'song-composer:create-draft:v1:';
const stagedDrafts = new Map<string, CreateDraft<unknown>>();

export type CreateDraft<T> = {
  fields: T;
  projectId: string | null;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function createDraftScope(connectionId: string, libraryId: string): string {
  return `${connectionId}:${libraryId}`;
}

function storageKey(scope: string): string {
  return `${KEY_PREFIX}${encodeURIComponent(scope)}`;
}

export function readCreateDraft<T>(
  scope: string,
  parseFields: (value: unknown) => T | null,
): CreateDraft<T> | null {
  const staged = stagedDrafts.get(scope);
  if (staged) {
    const fields = parseFields(staged.fields);
    if (fields) return { fields, projectId: staged.projectId };
  }

  const value = readStoredJson('local', storageKey(scope));
  if (!isRecord(value) || value.version !== VERSION) return null;
  if (value.projectId !== null && typeof value.projectId !== 'string') return null;
  const fields = parseFields(value.fields);
  return fields ? { fields, projectId: value.projectId } : null;
}

export function stageCreateDraft<T>(scope: string, draft: CreateDraft<T>): void {
  stagedDrafts.set(scope, draft as CreateDraft<unknown>);
}

export function writeCreateDraft<T>(scope: string, draft: CreateDraft<T>): boolean {
  stageCreateDraft(scope, draft);
  return writeStoredJson('local', storageKey(scope), { version: VERSION, ...draft });
}
